import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useState } from "react";


export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}) {
  const [goTo, setGoTo] = useState("");

  const windowSize = 5;

  const startPage = Math.floor((currentPage - 1) / windowSize) * windowSize + 1;
  const endPage = Math.min(startPage + windowSize - 1, totalPages);

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  const handleGoTo = () => {
    const pageNum = Number(goTo);
    if (pageNum >= 1 && pageNum <= totalPages) {
      onPageChange(pageNum);
    }
    setGoTo("");
  };

  return (
    <div className="
      flex items-center justify-between mt-4
      gap-2
      flex-wrap overflow-x-auto
      p-2 rounded-2xl
      bg-white/10 backdrop-blur-xl border border-white/20
      shadow-lg
    ">

      {/* PREVIOUS */}
      <button
        onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
        className="
          flex items-center justify-center
          w-9 h-9
          rounded-xl
          bg-white/20 backdrop-blur
          border border-white/30
          hover:scale-105 transition
        "
      >
        <ChevronLeft className="w-5 h-5 text-slate-700" />
      </button>

      {/* PAGE NUMBERS */}
      <div className="flex gap-1">
        {pages.map((num) => (
          <button
            key={num}
            onClick={() => onPageChange(num)}
            className={`
              min-w-[34px] h-9 px-2
              rounded-xl text-sm font-medium
              transition
              ${
                currentPage === num
                  ? "bg-blue-600 text-white shadow"
                  : "bg-white/20 backdrop-blur border border-white/30 text-slate-700"
              }
            `}
          >
            {num}
          </button>
        ))} 

        {endPage < totalPages && (
          <>
            <span className="px-1 text-slate-500">...</span>
            <button
              onClick={() => onPageChange(totalPages)}
              className="
                min-w-[34px] h-9 px-2
                rounded-xl text-sm
                bg-white/20 backdrop-blur border border-white/30
              "
            >
              {totalPages}
            </button>
          </>
        )}
      </div>

      {/* NEXT */}
      <button
        onClick={() =>
          currentPage < totalPages && onPageChange(currentPage + 1)
        }
        className="
          flex items-center justify-center
          w-9 h-9
          rounded-xl
          bg-white/20 backdrop-blur
          border border-white/30
          hover:scale-105 transition
        "
      >
        <ChevronRight className="w-5 h-5 text-slate-700" />
      </button>

      {/* GO TO */}
      <div className="flex items-center gap-1 ml-2">
        <input
          type="number"
          min="1"
          max={totalPages}
          value={goTo}
          onChange={(e) => setGoTo(e.target.value)}
          placeholder="#"
          className="
            w-12 h-9 text-center
            rounded-xl border border-white/30
            bg-white/20 backdrop-blur
            text-sm outline-none
          "
        />

        <button
          onClick={handleGoTo}
          className="
            px-3 h-9 rounded-xl text-xs font-semibold
            bg-blue-600 text-white
            hover:bg-blue-700 transition
          "
        >
          Go
        </button>
      </div>

    </div>
  );
}

// // Pagination.jsx
// import { ChevronLeft, ChevronRight } from "lucide-react";
// import React, { useState } from "react";

// export default function Pagination({
//   currentPage,
//   totalPages,
//   onPageChange,
// }) {
//   const [goTo, setGoTo] = useState("");

//   // How many page numbers to show at once
//   const windowSize = 5;

//   // Calculate sliding window
//   const startPage = Math.floor((currentPage - 1) / windowSize) * windowSize + 1;
//   const endPage = Math.min(startPage + windowSize - 1, totalPages);

//   const pages = [];
//   for (let i = startPage; i <= endPage; i++) {
//     pages.push(i);
//   }

//   const handleGoTo = () => {
//     const pageNum = Number(goTo);
//     if (pageNum >= 1 && pageNum <= totalPages) {
//       onPageChange(pageNum);
//     }
//     setGoTo("");
//   };

//   return (
//     <div className="flex items-center justify-end mt-4
//   gap-2 sm:gap-3
//   flex-nowrap
//   overflow-x-auto
//   whitespace-nowrap">

//         {/* Go To Page */}
//       <div className="flex items-center gap-2">
//         <input
//           type="number"
//           min="1"
//           max={totalPages}
//           value={goTo}
//           onChange={(e) => setGoTo(e.target.value)}
//           placeholder="Go to"
//           className="w-15  px-2 py-1 border rounded-md text-sm"
//         />
//         <button
//           onClick={handleGoTo}
//           className="px-3 py-1 bg-blue-600 text-white text-sm rounded-md"
//         >
//           Go
//         </button>
//       </div>

//       {/* Previous Button */}
//       {/* Previous Button */}
// <button
//   onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
//   className="px-3 py-1 border rounded-md text-sm bg-white"
// >
//   {/* Mobile */}
//         <ChevronLeft className="w-4 h-4 sm:hidden" />

//         {/* Tablet & Desktop */}
//         <span className="hidden sm:inline">Prev</span>
//       </button>

//       {/* Page Numbers */}
//       <div className="flex gap-1">
//         {pages.map((num) => (
//           <button
//             key={num}
//             onClick={() => onPageChange(num)}
//             className={`px-3 py-1 rounded-md text-sm border ${
//               currentPage === num
//                 ? "bg-blue-600 text-white"
//                 : "bg-white hover:bg-blue-50"
//             }`}
//           >
//             {num}
//           </button>
//         ))}

//         {endPage < totalPages && (
//           <>
//             <span className="px-2">...</span>
//             <button
//               onClick={() => onPageChange(totalPages)}
//               className="px-3 py-1 rounded-md text-sm border bg-white hover:bg-blue-50"
//             >
//               {totalPages}
//             </button>
//           </>
//         )}
//       </div>

//       {/* Next Button */}
//       <button
//         onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
//         className="px-3 py-1 border rounded-md text-sm bg-white"
//       >
//         {/* Mobile */}
//         <ChevronRight className="w-4 h-4 sm:hidden" />

//         {/* Tablet & Desktop */}
//         <span className="hidden sm:inline">Next</span>
//       </button>

//     </div>
//   );
// }
